import { BudgetActions } from '../actions';
import { Budget } from '../stores';
import Immutable from 'seamless-immutable';

const initialState = Immutable(Budget);

export function budget(store = initialState, action) {
	switch (action.type) {
		case BudgetActions.GetAllBudgetsAction.Request: {
			return store.merge({
				isBudgetLoading: true
			});
		}
		case BudgetActions.GetAllBudgetsAction.Success: {
			return store.merge({
				budgets: action.payload.items,
				budgetTotals: action.payload.totalItems,
				isBudgetLoading: false
			});
		}
		case BudgetActions.GetAllBudgetsAction.Failure: {
			return store.merge({
				isBudgetLoading: false
			});
		}
		case BudgetActions.GetArchiveBudgetsAction.Request: {
			return store.merge({
				isArchiveBudgetLoading: true
			});
		}
		case BudgetActions.GetArchiveBudgetsAction.Success: {
			return store.merge({
				archiveBudgets: action.payload.items,
				archiveBudgetTotals: action.payload.totalItems,
				isArchiveBudgetLoading: false
			});
		}
		case BudgetActions.GetArchiveBudgetsAction.Failure: {
			return store.merge({
				isArchiveBudgetLoading: false
			});
		}
		case BudgetActions.GetBudgetResultsAction.Request: {
			return store.merge({ isBudgetResultLoading: true });
		}
		case BudgetActions.GetBudgetResultsAction.Success: {
			return store.merge({
				results: action.payload,
				isBudgetResultLoading: false
			});
		}
		case BudgetActions.GetBudgetResultsAction.Failure: {
			return store.merge({ isBudgetResultLoading: false });
		}
		default: {
			return store;
		}
	}
}
